var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumStatus = function SvgNumStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "num-status_svg2__a",
    x1: -31.75,
    x2: 110.56,
    y1: 169.03,
    y2: -12.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#num-status_svg2__a",
    id: "num-status_svg2__b",
    x1: 48.54,
    x2: 190.84,
    y1: 232.06,
    y2: 50.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#num-status_svg2__a",
    id: "num-status_svg2__c",
    x1: -16.69,
    x2: 125.62,
    y1: 180.86,
    y2: -0.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#num-status_svg2__a",
    id: "num-status_svg2__d",
    x1: 29.8,
    x2: 172.11,
    y1: 217.35,
    y2: 36.08
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M73.97 13.79c-2.07 0-3.45 1.38-3.45 3.45s1.38 3.45 3.45 3.45h26.9c2.07 0 3.45-1.38 3.45-3.45s-1.38-3.45-3.45-3.45z",
    style: {
      fill: "url(#num-status_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.52 186.21h13.45c2.07 0 3.45-1.38 3.45-3.45s-1.38-3.45-3.45-3.45H80.52c-2.07 0-3.45 1.38-3.45 3.45s1.38 3.45 3.45 3.45",
    style: {
      strokeWidth: 0,
      fill: "url(#num-status_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.52 86.21c2.07 0 3.45-1.38 3.45-3.45V20.34c0-11.03-8.62-20.34-20-20.34h-73.8c-11.03 0-20 9.31-20 20.34v69.31c0 2.07 1.38 3.45 3.45 3.45s3.45-1.38 3.45-3.45V20.34c0-7.24 5.52-13.45 13.1-13.45h74.14c7.24 0 13.1 6.21 13.1 13.45v62.41c-.34 2.07 1.38 3.45 3.1 3.45Z",
    style: {
      strokeWidth: 0,
      fill: "url(#num-status_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.17 179.66c0 11.03 8.62 20.34 20 20.34h74.14c11.03 0 20-9.31 20-20.34V106.9h22.41c2.07 0 3.45-1.38 3.45-3.45s-1.38-3.45-3.45-3.45h-35.17l-2.76-14.48c-.34-1.72-1.72-2.76-3.45-2.76s-3.1 1.03-3.45 2.76l-5.52 29.66-4.83-60.34c0-2.07-1.72-3.45-3.79-3.1-1.38 0-2.76 1.03-3.1 2.41l-15.17 47.93-6.55-10.69c-.34-1.03-1.38-1.72-2.41-1.72s-2.41.69-3.1 1.38l-5.86 8.97H33.28c-2.07 0-3.45 1.38-3.45 3.45v76.21h.34Zm43.11-72.76c1.03 0 2.07-.69 2.76-1.38l3.79-5.86 7.59 12.41c1.03 1.72 3.1 2.07 4.83 1.03.69-.34 1.38-1.03 1.38-2.07l12.07-38.28 5.52 68.62c0 1.72 1.38 3.1 3.1 3.1h.34c1.72 0 3.1-1.03 3.45-2.76l6.9-37.59c.34 1.38 1.72 2.41 3.45 2.41h8.62v72.76c0 7.24-5.52 13.45-13.1 13.45H50.17c-7.24 0-13.1-6.21-13.1-13.45v-72.41h36.21Z",
    style: {
      strokeWidth: 0,
      fill: "url(#num-status_svg2__d)"
    }
  }));
};
export default SvgNumStatus;